import type { TrainingParticipantChapter } from "@repo/app-types/entities/trainingParticipant";
import type { FC } from "react";
import { chapterStatusDescriptions } from "./chapterHelpers.js";

export interface ChapterTooltipStatusLineProps {
  chapter: TrainingParticipantChapter;
}

export const ChapterTooltipStatusLine: FC<ChapterTooltipStatusLineProps> = ({
  chapter,
}) => {
  return (
    <div className="overflow-hidden">
      <span className="font-semibold">Status:</span>{" "}
      <span className="truncate">
        {chapterStatusDescriptions[chapter.status]}
      </span>
    </div>
  );
};
